import { render, staticRenderFns } from "./TemplatePopup.vue?vue&type=template&id=2cf50ce9&"
import script from "./TemplatePopup.vue?vue&type=script&lang=js&"
export * from "./TemplatePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports